import Axios from 'axios';
import { getAuthToken, clearSessionStorage } from '../utils/session';

export const httpInterceptor = Axios.create({
  baseURL: process.env.REACT_APP_API_URL + process.env.REACT_APP_API_URI
});

let interceptorsInitialized = false;

const setRequest = config => {
  const isFormData =
    typeof FormData !== 'undefined' && config?.data instanceof FormData;

  if (isFormData) {
    delete config.headers['content-Type'];
    delete config.headers['Content-Type'];
  } else {
    config.headers['content-Type'] = 'application/json';
  }
  config.headers['Access-Control-Allow-Origin'] = '*';
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
};

const printToConsoleError = (message, error) => {
  console.error(
    `error HttpManagement url: ${error.config.method?.toUpperCase()} ${
      error.config.baseURL
    }${error.config.url}`
  );
  if (error.response && error.response.data.error) {
    const responseData = error.response.data.error;
    console.error(`error HttpManagement message: ${responseData.message}`);
  }
};

const httpResponseHandling = response => {
  if (response.status === 200 || response.status === 201) {
    return response.data;
  } else {
    // CALL HTTP HANDLE ERROR
    console.error('Error connect service');
  }
};

const httpErrorHandling = error => {
  let message;
  if (error?.response?.status === 401) {
    clearSessionStorage();
    if (typeof window !== 'undefined' && window.location.pathname !== '/login') {
      window.location.href = '/login';
    }
    throw error;
  }

  if (
    error?.response?.statusText === 'Internal Server Error' &&
    error?.response?.status === 500
  ) {
    message = `Internal server error`;
    printToConsoleError(message, error);
    throw message;
  }

  if (
    error?.response?.statusText === 'Not Found' &&
    error?.response?.status === 404
  ) {
    message = `SERVICE NOT FOUND`;
    printToConsoleError(message, error);
    throw message;
  }
  if (
    error?.response?.statusText === 'Unprocessable Entity' &&
    error?.response?.status === 422
  ) {
    message = `MIN LENGTH`;
    printToConsoleError(message, error);
    throw message;
  }

  throw error;
};

function initializeInterceptors() {
  if (interceptorsInitialized) return;

  httpInterceptor.interceptors.request.use(config => setRequest(config));
  httpInterceptor.interceptors.response.use(
    res => httpResponseHandling(res),
    error => httpErrorHandling(error)
  );

  interceptorsInitialized = true;
}

// Se registra al importar el módulo para evitar condiciones de carrera
// en recargas donde la primera petición sale antes del montaje del provider.
initializeInterceptors();

function HttpManagement(props) {
  return props.children;
}

export default HttpManagement;
